module.exports = __webpack_public_path__ + "img/perso.6140f797.png";